import React from "react";
import { Progress } from 'antd';
import PropTypes from 'prop-types';
import EvaluationSurveyData from './EvaluationSurveyData';

const EvaluationProgress = ({ currentQuestionIndex }) => {
  const questionsCount = EvaluationSurveyData.questions.length;
  const currentPercent = Math.min( Math.ceil((100 * (currentQuestionIndex + 1)) / questionsCount), 99.999 );
  
  const getProgressLabel = () => `${currentQuestionIndex + 1} de ${questionsCount}`;

  return (
    <Progress
      type="line"
      format={getProgressLabel}
      percent={currentPercent}
      className="investor-profile-progress"
    />
  );
};

EvaluationProgress.propTypes = {
  currentQuestionIndex: PropTypes.number.isRequired,
};

export default EvaluationProgress;